var _rect, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAddHomeScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 43,
    height: 43,
    rx: 3.5,
    stroke: "#062134",
    strokeWidth: 7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 25,
    x2: 36,
    y2: 25,
    stroke: "#062134",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 36,
    x2: 25,
    y2: 14,
    stroke: "#062134",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAddHomeScreen);
export default __webpack_public_path__ + "static/media/ico_add_home_screen.479c6a8ad0bf8c0a3539054468a072cf.svg";
export { ForwardRef as ReactComponent };